export const AUTH_RETURN_STORAGE_KEY = 'tgp.authReturnTo';

export function validateRetrocriticReturnTo(
  value: string | null | undefined,
  retrocriticOrigin: string,
): string | null {
  if (!value || !retrocriticOrigin) return null;
  try {
    const target = new URL(value);
    const allowed = new URL(retrocriticOrigin);
    if (target.origin !== allowed.origin || target.pathname !== '/auth/login') return null;
    return target.href;
  } catch {
    return null;
  }
}

export function captureAuthReturn(search: string, storage: Storage, retrocriticOrigin: string): string | null {
  const candidate = validateRetrocriticReturnTo(new URLSearchParams(search).get('returnTo'), retrocriticOrigin);
  if (candidate) storage.setItem(AUTH_RETURN_STORAGE_KEY, candidate);
  return candidate;
}

export function consumeAuthReturn(storage: Storage): string | null {
  const value = storage.getItem(AUTH_RETURN_STORAGE_KEY);
  if (value) storage.removeItem(AUTH_RETURN_STORAGE_KEY);
  return value;
}
